import { ref } from 'vue';
import { createGlobalState } from '@vueuse/core';

export const useHistoryDialog = createGlobalState(() => {
    const dialogRef = ref<{ openDialog: () => void; closeDialog: () => void } | null>(null);

    function setDialogRef(ref: { openDialog: () => void; closeDialog: () => void } | null) {
        dialogRef.value = ref;
    }

    function open() {
        dialogRef.value?.openDialog();
    }

    function close() {
        dialogRef.value?.closeDialog();
    }

    return {
        dialogRef,
        setDialogRef,
        open,
        close,
    };
});
